(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["text"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('collapsible-text')) {
    class CollapsibleText extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('[data-content]');
        this.toggle = this.querySelector('[data-toggle]');
        if (!this.content || !this.toggle) return;

        this.handleClick = this.handleClick.bind(this);
        this.toggle.addEventListener('click', this.handleClick);

        // Re-check overflow when the viewport (and so the vh-based max height)
        // or the text content changes size.
        this.observer = new ResizeObserver(() => this.checkOverflow());
        this.observer.observe(this.content);
        if (this.content.firstElementChild) this.observer.observe(this.content.firstElementChild);

        this.checkOverflow();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.toggle?.removeEventListener('click', this.handleClick);
      }

      get expanded() {
        return this.hasAttribute('data-expanded');
      }

      get reducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      checkOverflow() {
        if (this.expanded) return;
        const overflowing = this.content.scrollHeight > this.content.clientHeight + 1;
        this.toggleAttribute('data-overflowing', overflowing);
        this.toggle.hidden = !overflowing;
      }

      handleClick() {
        this.expanded ? this.collapse() : this.expand();
      }

      expand() {
        const content = this.content;
        this.setExpanded(true);

        if (this.reducedMotion) {
          content.style.maxHeight = 'none';
          return;
        }

        content.style.maxHeight = `${content.scrollHeight}px`;
        content.addEventListener(
          'transitionend',
          () => {
            // Remove the cap so later content/resize changes aren't clipped
            if (this.expanded) content.style.maxHeight = 'none';
          },
          { once: true }
        );
      }

      collapse() {
        const content = this.content;

        // Go from "none" to a pixel value first so the transition has a start point
        content.style.maxHeight = `${content.scrollHeight}px`;
        content.offsetHeight; // force reflow
        content.style.maxHeight = ''; // back to the vh-based value from CSS

        this.setExpanded(false);

        // If the top of the block scrolled out of view while expanded, bring it back
        if (this.getBoundingClientRect().top < 0) {
          this.scrollIntoView({ block: 'start', behavior: this.reducedMotion ? 'auto' : 'smooth' });
        }
      }

      setExpanded(expanded) {
        this.toggleAttribute('data-expanded', expanded);
        this.toggle.setAttribute('aria-expanded', String(expanded));
        this.toggle.querySelector('[data-label-expand]').hidden = expanded;
        this.toggle.querySelector('[data-label-collapse]').hidden = !expanded;
      }
    }

    customElements.define('collapsible-text', CollapsibleText);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('milestone-descriptor')) {
    customElements.define(
      'milestone-descriptor',
      class MilestoneDescriptor extends HTMLElement {
        constructor() {
          super();
          this.handleVariantUpdate = this.handleVariantUpdate.bind(this);
        }

        connectedCallback() {
          document.addEventListener('variant:update', this.handleVariantUpdate);
        }

        disconnectedCallback() {
          document.removeEventListener('variant:update', this.handleVariantUpdate);
        }

        handleVariantUpdate(event) {
          // Only react to the variant picker in the same section
          const section = this.closest('.shopify-section');
          if (section && event.target instanceof Node && event.target !== document && !section.contains(event.target)) {
            return;
          }

          const detail = event.detail || {};

          // 1. Preferred: read the server-rendered state from the refreshed section HTML
          let html = detail.data && detail.data.html;
          if (typeof html === 'string') {
            html = new DOMParser().parseFromString(html, 'text/html');
          }
          const fresh = html && html.querySelector ? html.querySelector('#' + CSS.escape(this.id)) : null;
          if (fresh) {
            this.hidden = fresh.hasAttribute('hidden');
            return;
          }

          // 2. Fallback: check the selected variant's release criteria value directly
          const variant = detail.resource;
          if (!variant) return;

          const position = Number(this.dataset.optionPosition);
          const raw = (variant.options && variant.options[position - 1]) || variant['option' + position] || '';
          const selected = String(raw).trim().toLowerCase();
          const targets = (this.dataset.milestoneValues || '')
            .split(',')
            .map((value) => value.trim())
            .filter(Boolean);

          this.hidden = !targets.includes(selected);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
